import React from 'react'

const Footer = () => {
  return (
    <p className='text-sm text-black dark:text-white text-center py-10 md:py-14 lg:py-16'>ⓒ SudeshBhat 2022</p>
  )
}

export default Footer